import React from 'react';
import { bool, number, node, string, func } from 'prop-types';
import styled from 'styled-components';
import { layout, background } from 'styled-system';

import ResponsiveModal from '../Modal/ResponsiveModal';
import Button from '../Button';
import Text from '../Text/Text';
import Wrapper from '../Wrapper';
import ProgressBar from '../ProgressBar';
import CloseIcon from './CloseIcon';

const CheckoutAnimationWrapper = styled(Wrapper)`
  background-image: url(${props => props.animation});
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  ${layout};
  ${background};
`;

const StyledButton = styled(Button)`
  margin-bottom: 16px;
  ${layout};
`;

const modalStyle = {
  top: ['30%', '50%'],
  bottom: 'auto',
  style: {
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
      zIndex: 101,
    },
  },
};

const FeedbackModal = ({
  timeout,
  isVisible,
  background,
  backgroundSize,
  title,
  subTitle,
  primaryLabel,
  primaryClick,
  secondaryLabel,
  secondaryClick,
  textAlignment,
  width,
  buttonWidth,
  showCloseIcon,
  closeClick,
  move,
  errorButton,
}) => {
  return (
    <ResponsiveModal
      isOpen={isVisible}
      width={[0.8, width]}
      modalStyle={modalStyle}
      onCancelConfirm={() => {}}
    >
      <Wrapper>
        {showCloseIcon && <CloseIcon onClick={closeClick} />}
        <CheckoutAnimationWrapper
          animation={background}
          height={['142px', '166px']}
          width="244px"
          margin={['52px auto 0 auto', '64px auto 0 auto']}
          backgroundSize={backgroundSize}
        />
        <Wrapper
          marginTop="16px"
          marginBottom="32px"
          padding="0 32px"
          display="flex"
          flexDirection="column"
          alignItems={textAlignment}
          textAlign={textAlignment}
        >
          <Text
            fontSize="16px"
            lineHeight="20px"
            fontWeight="500"
            color="black"
            marginBottom="8px"
            textAlign={textAlignment}
          >
            {title}
          </Text>
          <Text
            fontSize="14px"
            lineHeight="22px"
            color="greyDark"
            textAlign={textAlignment}
          >
            {subTitle}
          </Text>
          {!title && !subTitle && <ProgressBar timeout={timeout} />}
        </Wrapper>
        <Wrapper
          marginTop="38px"
          marginBottom={['18px', '16px']}
          alignItems="center"
          display="flex"
          flexWrap="wrap"
          justifyContent={
            primaryLabel && secondaryLabel ? 'space-between' : 'center'
          }
          padding={['0 24px', '0 32px']}
        >
          {secondaryLabel && (
            <StyledButton
              big
              secondary
              block
              onClick={secondaryClick}
              width={['100%', buttonWidth + 'px']}
              border={move && '#023C40'}
              borderRadius={move && '32px'}
              hovercolor={move && '#E8F2EC'}
              backgroundColor={move && '#FFFFFF'}
              errorButton={errorButton}
            >
              {secondaryLabel}
            </StyledButton>
          )}
          {primaryLabel && (
            <StyledButton
              big
              primary
              block
              onClick={primaryClick}
              width={['100%', buttonWidth + 'px']}
              border={move && '#023C40'}
              borderRadius={move && '32px'}
              hovercolor={move && '#12C25A'}
              backgroundColor={move && '#0CE865'}
              errorButton={errorButton}
            >
              {primaryLabel}
            </StyledButton>
          )}
        </Wrapper>
      </Wrapper>
    </ResponsiveModal>
  );
};

FeedbackModal.propTypes = {
  isVisible: bool.isRequired,
  timeout: number,
  background: node.isRequired,
  backgroundSize: string,
  title: string,
  subTitle: string,
  primaryLabel: string,
  primaryClick: func,
  secondaryLabel: string,
  secondaryClick: func,
  textAlignment: string,
  width: number,
  buttonWidth: number,
  closeClick: func,
  showCloseIcon: bool,
  move: bool,
  errorButton: bool,
};

FeedbackModal.defaultProps = {
  backgroundSize: 'contain',
  textAlignment: 'center',
  width: 456,
  buttonWidth: 188,
  closeClick: () => {},
  showCloseIcon: false,
};

export default FeedbackModal;
